<template>
  <div class="mt-4">
    <div class="flex justify-between flex-wrap md:flex-nowrap items-end mb-6">
      <button
        class="bg-blue-500 text-white py-2 px-3 rounded-lg flex items-center outline-none shadow-sm hover:shadow-blue-500"
        @click="activeModalRegister"
      >
        <font-awesome-icon icon="fa-solid fa-plus" class="mr-2" />
        Nuevo registro
      </button>

      <!-- componente para las sucursales -->
      <label class="block mt-3 md:mt-0 w-full md:w-auto">
        <span class="block text-gray-600 font-semibold mb-1">Sucursales</span>
        <select
          v-model="idstore"
          @change="resetValuesAndGetData"
          class="bg-white border py-2 text-sm px-3 text-gray-600 cursor-pointer rounded-lg mr-3 outline-none min-w-[140px] font-semibold w-full"
        >
          <option
            :value="dataStore.id"
            v-for="(dataStore, i) in dataStores"
            :key="i"
          >
            {{ dataStore.razon_social }}
          </option>
        </select>
      </label>
    </div>
    <div class="rounded-lg overflow-hidden border">
      <!-- secction para filtar por limite de registro -->
      <div class="py-4 px-3 flex items-center justify-between">
        <select
          v-model="limitRegister"
          class="bg-white border py-2 text-sm px-3 text-gray-600 cursor-pointer rounded-lg mr-3 outline-none min-w-[140px] font-semibold"
          @change="resetValuesAndGetData"
        >
          <option value="10">10 Registros</option>
          <option value="25">25 Registros</option>
          <option value="50">50 Registros</option>
          <option value="100">100 Registros</option>
        </select>
        <div class="w-full">
          <label for="modules">
            <input
              type="text"
              class="py-2 px-2 text-sm bg-white border outline-none rounded-lg shadow-sm text-gray-600 w-full"
              placeholder="Buscar por nombre de usuario..."
              v-model="search"
              @keydown.enter="resetValuesAndGetData"
            />
          </label>
        </div>
      </div>

      <!-- seccion de conteido de datos tablas
          1: Para poner una tabla responsiva añadir lo siguiente:
            1.1: class="resize-generate"
            1.2: ref="widthNav" 
            1.3: @resize="handleResize"
          -->
      <div
        class="w-full resize-x resize-generate"
        ref="widthNav"
        @resize="handleResize"
      >
        <div class="overflow-x-auto">
          <table class="table-auto w-full">
            <TableHead :headers="header" />
            <LoadingTables v-if="loading" :columns="6" />
            <tbody class="text-gray-500 text-left border-t-[1px]" v-else>
              <tr
                v-for="(register, i) in registers"
                :key="i"
                class="hover:bg-blue-500 transition-colors hover:text-white capitalize font-semibold odd:bg-white even:bg-slate-50"
              >
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap"
                >
                  {{ register.nombre_completo }}
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap"
                >
                  {{ register.turno }}
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap uppercase"
                >
                  {{ register.dias }}
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap"
                >
                  <span
                    class="px-2 rounded-tl-xl rounded-bl-xl text-[12px] py-1 font-bold text-gray-600 bg-green-200"
                  >
                    {{ formatTime(register.hora_de_ingreso) }}
                  </span>
                  <span
                    class="px-2 rounded-tr-xl rounded-br-xl text-[12px] py-1 font-bold text-gray-600 bg-orange-200"
                  >
                    {{ formatTime(register.hora_de_ingreso_tolerancia) }}
                  </span>
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 whitespace-nowrap"
                >
                  <span
                    class="px-2 rounded-tl-xl rounded-bl-xl text-[12px] py-1 font-bold text-gray-600 bg-red-200"
                  >
                    {{ formatTime(register.hora_de_salida) }}
                  </span>
                  <span
                    class="px-2 rounded-tr-xl rounded-br-xl text-[12px] py-1 font-bold text-gray-600 bg-orange-200"
                  >
                    {{ formatTime(register.hora_de_salida_tolerancia) }}
                  </span>
                </td>
                <td
                  class="border-slate-200 text-sm px-6 py-2 text-right whitespace-nowrap"
                >
                  <button
                    class="bg-blue-100 text-blue-500 hover:text-white py-1 px-2 rounded-md text-sm active:scale-105 hover:bg-blue-700"
                    @click="activeModalUpdate(register.id)"
                  >
                    <font-awesome-icon icon="fa-solid fa-pen" class="w-3 h-3" />
                  </button>
                  <button
                    class="bg-red-50 ml-3 text-red-500 hover:bg-red-500 hover:text-white py-1 px-2 rounded-md text-sm active:scale-105"
                    @click="isDelete(register.nombre_completo, register.id)"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-trash"
                      class="w-3 h-3"
                    />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <TablePagination
        :currentPage="currentPage"
        :total="totalPage"
        :next="next"
        :prev="prev"
      />
    </div>
  </div>

  <RegisterWorkSchedules
    :activeModal="activeModalRegister"
    :getdata="getData"
    v-if="stateRegister"
  />
  <UpdateWorkSchedules
    :activeModal="activeModalUpdate"
    :getdata="getData"
    :id="id"
    v-if="stateUpdate"
  />
</template>

<script>
import { onBeforeMount, onMounted, ref, watchEffect } from "vue";
import axios from "../../../api";
import LoadingTables from "@/components/Loadings/LoadingTables";
import TableHead from "@/components/TablesComponents/TableHead";
import TablePagination from "@/components/TablesComponents/TablePagination.vue";
import RegisterWorkSchedules from "@/components/Users/WorkSchedules/RegisterWorkSchedules.vue";
import UpdateWorkSchedules from "@/components/Users/WorkSchedules/UpdateWorkSchedules.vue";
import Swal from "sweetalert2";
import { errorActions, warningActions } from "@/alerts";

//days js
const dayjs = require("dayjs");
import customParseFormat from "dayjs/plugin/customParseFormat";
import { idLocalStore } from '@/publicjs/localStorage';
dayjs.extend(customParseFormat);
//fin days js

export default {
  name: "MainWorkSchedules",
  components: {
    LoadingTables,
    TableHead,
    TablePagination,
    RegisterWorkSchedules,
    UpdateWorkSchedules,
  },
  setup() {
    // carga de datos a la tabla
    const registers = ref([]);
    const paginate = ["registers"];
    const loading = ref(true);
    const header = [
      [
        {
          title: "Nombres y apellidos",
        },
        {
          title: "Turno",
        },
        {
          title: "permanencia",
        },
        {
          title: "Hora de ingreso",
        },
        {
          title: "hora de salida",
        },
        {
          title: "Acciones",
        },
      ],
    ];

    //variables de paginacion
    const currentPage = ref(1);
    const limitRegister = ref(10);
    const search = ref("");
    const resgisterPaginate = ref(null);
    const totalPage = ref(0);
    //sucursales
    const idstore = ref(0);
    const getData = async () => {
      loading.value = true;
      const response = await axios
        .get(
          `horarios/?page=${currentPage.value}&per_page=${limitRegister.value}&search=${search.value}&idstore=${idstore.value}`
        )
        .catch((error) => errorActions(error));

      // validacion para mostrar una alerta cuando no se ha encontrado un registro
      if ((await response.data.data.length) === 0) {
        warningActions(
          "Los sentimos no pudimos encontrar lo que estabas buscando 😥"
        );
      }
      registers.value = await response.data.data;
      resgisterPaginate.value = await response.data;
      totalPage.value = resgisterPaginate.value.last_page;
      loading.value = false;
    };

    //funcion para recetear valores
    const resetValuesAndGetData = async () => {
      currentPage.value = 1;
      await getData();
    };

    //calcular el ancho del nav y hacer el scroll en x de la tabla
    const widthNav = ref(null);
    const handleResize = () => {
      const nav = document.querySelector("nav").offsetWidth;
      watchEffect(
        () => {
          if (widthNav.value) {
            widthNav.value.style.width = `calc(100vw - ${nav + 42}px)`;
          }
        },
        // { immediate: true }
      );
    };

    //funcion para formatear horas usando daysj

    const formatTime = (time) => dayjs(time, "HH:mm:ss").format("hh:mm:ss A");

    // funcion para cargar las sucursales
    const dataStores = ref([]);
    const getStores = async () => {
      const response = await axios.get("sucursales").catch((error) => {
        errorActions(error);
      });
      if ((await response.data.data.length) === 0) {
        errorActions("No pudimos encontrar las sucursales");
      }
      dataStores.value = await response.data.data;
      idstore.value = dataStores.value[0].id;
    };

    onBeforeMount(async () => {
      await getStores();
      idstore.value = await idLocalStore()
      await getData();
    })
    onMounted(async () => {
      handleResize();
      window.addEventListener("resize", handleResize);
      // await getStores();
      // await getData();
    });

    //! Funciones para avanzar y retrocedeer en la paginaciones
    const next = async () => {
      totalPage.value = resgisterPaginate.value.last_page;
      if (currentPage.value <= totalPage.value - 1) currentPage.value++;
      await getData();
    };
    const prev = async () => {
      totalPage.value = resgisterPaginate.value.last_page;
      if (currentPage.value >= 2) currentPage.value--;
      await getData();
    };

    //activar modal de registro y de actualizacion de datos
    const stateRegister = ref(false);
    const stateUpdate = ref(false);
    const activeModalRegister = () => {
      stateRegister.value = !stateRegister.value;
    };

    const id = ref(0);
    const activeModalUpdate = (idData) => {
      stateUpdate.value = !stateUpdate.value;
      id.value = idData;
    };

    //Acciones para eliminar
    const deleteData = async (register, id) => {
      const response = await axios
        .delete("horarios/" + id, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .catch(function (error) {
          errorActions(error);
        });
      const data = response.data;
      if (data.msg === "Request failed with status code 500") {
        errorActions(data.msg);
      } else if (data.msg === false) {
        errorActions(
          "Lo sentimos no pudimos eliminar el horario del usuario " + register
        );
      }
    };
    //SweetAlert para confirmas la eliminacion del registro
    const isDelete = (register, id) => {
      Swal.fire({
        title: "¿Estas seguro que deseas eliminar el horario?",
        text: `Si eliminas el horario del usuario ${register}, no podras recuperarlo más adelante!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#315df5",
        cancelButtonColor: "#dc2626",
        confirmButtonText: "Si, ¡Eliminar!",
        cancelButtonText: "Cancelar",
        width: "300px",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await deleteData(register, id);
          Swal.fire({
            icon: "success",
            title: "Eliminado",
            text: `Horario del usuario ${register}, a sido eliminado de la base de datos`,
            confirmButtonColor: "#315df5",
            confirmButtonText: "Aceptar!",
          });

          await getData();
        }
      });
    };

    return {
      loading,
      getData,
      paginate,
      header,
      registers,
      limitRegister,
      currentPage,
      search,
      next,
      prev,
      totalPage,
      resetValuesAndGetData,
      activeModalRegister,
      stateRegister,
      activeModalUpdate,
      isDelete,
      id,
      stateUpdate,
      widthNav,
      handleResize,
      idstore,
      dataStores,
      formatTime,
    };
  },
};
</script>

<style scoped>
.active button svg {
  rotate: 90deg;
}
</style>
